import React from 'react';
import { Link } from 'react-router-dom';
import './ExitVerificationButton.css';

const ExitVerificationButton = ({ routes, hasSubscription }) => {
  return (
    <Link
      to={hasSubscription ? routes.welcome : routes.signupPlans}
      className="exitVerificationButton"
      /* 
      reloadDocument has it reload the entire site. This allows the Akamai redirect to take effect and
      redirect from '/' to '/featured' for the active subscriber.
      This is the equivalent of doing window.location.replace(rootDomain)
      */
      reloadDocument={!!hasSubscription}
    >
      <img src="/account/static/images/cross-mark-white.svg" className="exitVerificationIcon" alt="exit" />
      Exit Verification
    </Link>
  );
};

export default ExitVerificationButton;
